module.exports = __webpack_public_path__ + "static/img/img_neural network@2x.5eda97b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_neural network@2x.png
// module id = YltK
// module chunks = 0